// VENDITE_v1 — 🧾 Vendite dentro la Cassetta: fatture emesse lette dagli XML, fatturato e da incassare
import React, { useState, useEffect, useMemo } from "react";
import { statoFatture, proponiCantiere, ivaPerMese, eNota, giorniDa } from "./venditeCalcoli";

const C = {
  bg: "#0f1117", surface: "#1a1d27", surface2: "#21253a", border: "#2a2e45", accent: "#f5a623",
  text: "#e8eaf2", muted: "#7b82a0", dim: "#4a5068", ok: "#3ecf8e", err: "#f06060", info: "#4e9af5",
};
const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const STATI = {
  aperta: ["Da incassare", C.err], parziale: ["In parte incassata", C.accent], incassata: ["Incassata", C.ok],
  stornata: ["Annullata da nota di credito", C.dim], nota: ["Nota di credito", C.info],
};
function tok() { try { return localStorage.getItem("bertoc_jwt") || ""; } catch (e) { return ""; } }
async function api(url, opts) {
  const o = opts || {};
  const h = { Authorization: "Bearer " + tok() };
  if (o.body) h["Content-Type"] = "application/json";
  const r = await fetch(url, { method: o.method || "GET", headers: h, body: o.body ? JSON.stringify(o.body) : undefined });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || ("Errore " + r.status));
  return j;
}
const euro = n => (Number(n) < 0 ? "− " : "") + "€ " + Math.abs(Number(n) || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const dataIt = s => /^\d{4}-\d{2}-\d{2}/.test(s || "") ? s.slice(8, 10) + "/" + s.slice(5, 7) + "/" + s.slice(0, 4) : (s || "");
const st = {
  card: { background: C.surface, border: "1px solid " + C.border, borderRadius: 12, padding: 16, marginBottom: 14 },
  titolo: { fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: 15, marginBottom: 10 },
  nota: { fontSize: 12, color: C.muted, lineHeight: 1.55 },
  inp: { padding: "8px 10px", fontSize: 15, borderRadius: 8, border: "1px solid " + C.border, background: C.bg, color: C.text, outline: "none", fontFamily: "inherit" },
  btn: primo => ({ padding: "9px 14px", borderRadius: 9, border: "1px solid " + (primo ? C.accent : C.border), background: primo ? C.accent : C.surface, color: primo ? "#1a1d27" : C.text, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }),
  chip: (on, col) => ({ padding: "7px 12px", borderRadius: 9, cursor: "pointer", fontSize: 13, fontWeight: 700, border: "1px solid " + (on ? col : C.border), background: on ? col + "22" : C.surface, color: on ? col : C.text, userSelect: "none", whiteSpace: "nowrap" }),
};

function Riquadro({ label, val, sotto, col }) {
  return (
    <div style={{ background: C.bg, border: "1px solid " + C.border, borderRadius: 10, padding: "10px 12px", minWidth: 0 }}>
      <div style={{ fontSize: 11, color: C.muted, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
      <div style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: 19, color: col || C.text, marginTop: 3, whiteSpace: "nowrap" }}>{val}</div>
      {sotto && <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{sotto}</div>}
    </div>
  );
}

function SceltaCantiere({ value, onChange, cantieri, disabled }) {
  return (
    <select style={{ ...st.inp, fontSize: 13, flex: 1, minWidth: 180, maxWidth: "100%" }} value={value} disabled={disabled} onChange={e => onChange(e.target.value)}>
      <option value="">— scegli il cantiere —</option>
      <option value="__nessuno">Nessun cantiere</option>
      {cantieri.map(c => <option key={c._id || c.id} value={c._id || c.id}>{c.nome}{c.cliente ? " · " + c.cliente : ""}{c.completato ? " (chiuso)" : ""}</option>)}
    </select>
  );
}

function Fattura({ v, s, aperta, onApri, cantieri, salva, occupato, oggi }) {
  const [col, cc] = [(STATI[s.stato] || STATI.aperta)[1], cantieri.find(x => (x._id || x.id) === v.cantiereId)];
  const nomeCant = cc ? cc.nome : v.cantiere;
  const giorni = giorniDa(v.data, oggi);
  const etichette = [];
  if (v.ritenuta) etichette.push("ritenuta " + euro(Math.abs(v.ritenuta)));
  if (v.split) etichette.push("split payment: il cliente paga senza IVA");
  if ((v.aliquote || []).some(a => /^N6/.test(a.natura || ""))) etichette.push("inversione contabile");
  return (
    <div style={{ borderTop: "1px solid " + C.border, padding: "9px 0", opacity: s.stato === "stornata" ? 0.6 : 1 }}>
      <div onClick={onApri} style={{ display: "flex", gap: 10, alignItems: "flex-start", cursor: "pointer" }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{(eNota(v) ? "NC " : "n. ") + v.numero + " · " + v.cliente}</div>
          <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>
            {dataIt(v.data)}{nomeCant ? " · 🏗️ " + nomeCant : (v.senzaCantiere ? " · senza cantiere" : " · cantiere da scegliere")}
          </div>
          <div style={{ fontSize: 12, color: col, marginTop: 2 }}>
            {(STATI[s.stato] || [""])[0]}{(s.stato === "aperta" || s.stato === "parziale") ? " da " + giorni + " giorni" : ""}{s.stato === "parziale" ? " · già arrivati " + euro(s.atteso - s.residuo) : ""}
          </div>
        </div>
        <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
          <div style={{ fontWeight: 800, color: s.residuo ? C.err : C.text }}>{s.residuo ? euro(s.residuo) : euro(v.totale)}</div>
          <div style={{ fontSize: 11, color: C.muted }}>{s.residuo ? "fattura " + euro(v.totale) : "imponibile " + euro(v.imponibile)}</div>
        </div>
      </div>
      {aperta && (
        <div style={{ marginTop: 8, padding: 12, borderRadius: 10, background: C.surface2, fontSize: 13 }}>
          <div style={{ color: C.text, marginBottom: 6, wordBreak: "break-word" }}>{v.descrizione}</div>
          <div style={st.nota}>Imponibile {euro(v.imponibile)} · IVA {euro(v.iva)} · totale {euro(v.totale)} · deve arrivare {euro(s.atteso)}{etichette.length ? " · " + etichette.join(" · ") : ""}</div>
          {(v.fattureCollegate || []).length > 0 && <div style={st.nota}>Si riferisce alla fattura n. {v.fattureCollegate.map(x => x.numero).join(", ")}</div>}
          {(v.incassi || []).map((x, i) => <div key={i} style={{ ...st.nota, color: C.ok }}>🏦 {dataIt(x.data)} · {euro(x.importo)} dalla banca</div>)}
          {v.incassataMano && <div style={{ ...st.nota, color: C.ok }}>✓ Segnata incassata a mano il {dataIt(v.incassataMano.data)}</div>}
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginTop: 10 }}>
            <SceltaCantiere value={v.cantiereId || (v.senzaCantiere ? "__nessuno" : "")} cantieri={cantieri} disabled={occupato}
              onChange={x => salva(v, x === "__nessuno" ? { cantiereId: "", senzaCantiere: true } : { cantiereId: x, senzaCantiere: false })} />
            {(s.stato === "aperta" || s.stato === "parziale") && <button style={{ ...st.btn(false), fontSize: 13, padding: "7px 12px" }} disabled={occupato} onClick={() => salva(v, { incassataMano: { data: oggi } })}>✓ Segna incassata</button>}
            {v.incassataMano && <button style={{ ...st.btn(false), fontSize: 13, padding: "7px 12px" }} disabled={occupato} onClick={() => salva(v, { incassataMano: null })}>Togli «incassata»</button>}
          </div>
        </div>
      )}
    </div>
  );
}

function DaCollegare({ fatture, cantieri, vendite, salvaLista, occupato }) {
  const [scelte, setScelte] = useState({});
  const prop = useMemo(() => { const o = {}; fatture.forEach(v => { o[v.id] = proponiCantiere(v, cantieri, vendite); }); return o; }, [fatture, cantieri, vendite]);
  const scelta = v => scelte[v.id] !== undefined ? scelte[v.id] : (prop[v.id].dubbio ? "" : prop[v.id].cantiereId);
  const pronte = fatture.filter(v => scelta(v));
  // quelle dello stesso cliente hanno spesso lo stesso cantiere: si propongono tutte insieme
  const ordinate = fatture.slice().sort((a, b) => String(a.cliente).localeCompare(String(b.cliente)) || String(a.data).localeCompare(String(b.data)));
  return (
    <div style={st.card}>
      <div style={st.titolo}>Da collegare a un cantiere ({fatture.length})</div>
      <div style={{ ...st.nota, marginBottom: 10 }}>Dove trovi già un cantiere è una proposta: controlla e premi il pulsante. Se una fattura non ha un cantiere nel gestionale scegli «Nessun cantiere».</div>
      {pronte.length > 0 && <button style={st.btn(true)} disabled={occupato} onClick={() => salvaLista(pronte.map(v => { const x = scelta(v); return x === "__nessuno" ? { id: v.id, cantiereId: "", senzaCantiere: true } : { id: v.id, cantiereId: x, senzaCantiere: false }; }))}>✓ Salva {pronte.length} {pronte.length === 1 ? "collegamento" : "collegamenti"}</button>}
      <div style={{ marginTop: 10 }}>
        {ordinate.map(v => (
          <div key={v.id} style={{ borderTop: "1px solid " + C.border, padding: "9px 0" }}>
            <div style={{ display: "flex", gap: 10, fontSize: 14, fontWeight: 700 }}><span style={{ flex: 1, minWidth: 0 }}>{(eNota(v) ? "NC " : "n. ") + v.numero + " · " + v.cliente}</span><span style={{ whiteSpace: "nowrap" }}>{euro(v.totale)}</span></div>
            <div style={{ ...st.nota, margin: "2px 0 6px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataIt(v.data)} · {v.descrizione}</div>
            <div style={{ display: "flex" }}><SceltaCantiere value={scelta(v)} cantieri={cantieri} disabled={occupato} onChange={x => setScelte(s => ({ ...s, [v.id]: x }))} /></div>
            {prop[v.id].dubbio && scelte[v.id] === undefined && <div style={{ fontSize: 12, color: C.accent, marginTop: 4 }}>Forse: {prop[v.id].altri.map(a => a.nome).join(" oppure ")}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function FattureVendita({ cantieriDB = [] }) {
  const [fatture, setFatture] = useState(null);
  const [pagamenti, setPagamenti] = useState([]);
  const [documenti, setDocumenti] = useState([]);
  const [anno, setAnno] = useState(String(new Date().getFullYear()));
  const [vista, setVista] = useState("incassare");
  const [aperta, setAperta] = useState("");
  const [cerca, setCerca] = useState("");
  const [avviso, setAvviso] = useState("");
  const [errore, setErrore] = useState("");
  const [occupato, setOccupato] = useState(false);
  const oggi = new Date().toISOString().slice(0, 10);

  async function ricarica() {
    try { setFatture((await api("/api/vendite")).fatture || []); setErrore(""); }
    catch (e) { setErrore(e.message); setFatture([]); }
    try { const pg = await api("/api/v2/pagamenti"); setPagamenti((Array.isArray(pg) ? pg : []).map(p => ({ ...p, id: p.id || p._id }))); } catch (e) {}
    try { setDocumenti((await api("/api/cassetta/documenti")).documenti || []); } catch (e) {}
  }
  useEffect(() => { ricarica(); }, []);

  async function importa() {
    setOccupato(true); setAvviso(""); setErrore("");
    try {
      const j = await api("/api/vendite/importa-nas", { method: "POST", body: { anno } });
      setAvviso("✓ " + anno + ": " + j.nuove + " fatture registrate" + (j.gia ? ", " + j.gia + " già presenti" : "") + (j.errori.length ? "\n⚠️ " + j.errori.join("\n⚠️ ") : ""));
      await ricarica();
      if (j.nuove) setVista("collega");
    } catch (e) { setErrore(e.message); }
    setOccupato(false);
  }
  async function salva(v, patch) {
    setOccupato(true);
    try { await api("/api/vendite/" + v.id, { method: "PATCH", body: patch }); await ricarica(); } catch (e) { alert(e.message); }
    setOccupato(false);
  }
  async function salvaLista(lista) {
    setOccupato(true);
    try {
      const j = await api("/api/vendite/collega", { method: "POST", body: { lista } });
      setAvviso("✓ " + j.fatti + " fatture collegate" + (j.errori.length ? "\n⚠️ " + j.errori.join("\n⚠️ ") : ""));
      await ricarica();
    } catch (e) { alert(e.message); }
    setOccupato(false);
  }

  const stato = useMemo(() => statoFatture(fatture || [], pagamenti), [fatture, pagamenti]);
  const cantOrd = useMemo(() => cantieriDB.filter(c => !/pippo/i.test(c.nome || "")).sort((a, b) => (a.completato ? 1 : 0) - (b.completato ? 1 : 0) || String(a.nome || "").localeCompare(String(b.nome || ""))), [cantieriDB]);
  if (fatture === null) return <div style={{ ...st.card, color: C.muted }}>Carico le fatture di vendita…</div>;

  const anni = Array.from(new Set(fatture.map(v => String(v.data || "").slice(0, 4)).filter(Boolean).concat(String(new Date().getFullYear())))).sort().reverse();
  const dellAnno = fatture.filter(v => String(v.data || "").startsWith(anno));
  const imponibile = dellAnno.reduce((s, v) => s + (Number(v.imponibile) || 0), 0);
  const iva = dellAnno.reduce((s, v) => s + (Number(v.iva) || 0), 0);
  const nFatture = dellAnno.filter(v => !eNota(v)).length, nNote = dellAnno.length - nFatture;
  const aperte = fatture.filter(v => stato.perId[v.id] && stato.perId[v.id].residuo > 0).sort((a, b) => String(a.data).localeCompare(String(b.data)));
  const daIncassare = aperte.reduce((s, v) => s + stato.perId[v.id].residuo, 0);
  const vecchie = aperte.filter(v => giorniDa(v.data, oggi) > 30);
  const daCollegare = fatture.filter(v => !v.cantiereId && !v.senzaCantiere);
  const q = cerca.trim().toLowerCase();
  const tutte = dellAnno.filter(v => !q || [v.cliente, v.numero, v.descrizione, v.cantiere].join(" ").toLowerCase().includes(q)).sort((a, b) => String(b.data).localeCompare(String(a.data)) || (parseInt(b.numero, 10) || 0) - (parseInt(a.numero, 10) || 0));
  const nomeCant = id => { const c = cantieriDB.find(x => (x._id || x.id) === id); return c ? c.nome : "(cantiere tolto)"; };
  const perCantiere = Object.values(stato.cantieri).sort((a, b) => b.daIncassare - a.daIncassare || b.totale - a.totale);
  const senzaCant = fatture.filter(v => !v.cantiereId && stato.perId[v.id] && stato.perId[v.id].residuo > 0).reduce((s, v) => s + stato.perId[v.id].residuo, 0);
  const iv = vista === "iva" ? ivaPerMese(fatture, documenti, anno) : [];
  const riga = v => <Fattura key={v.id} v={v} s={stato.perId[v.id]} aperta={aperta === v.id} onApri={() => setAperta(aperta === v.id ? "" : v.id)} cantieri={cantOrd} salva={salva} occupato={occupato} oggi={oggi} />;

  return (
    <div>
      <div style={{ ...st.card, display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 220 }}>
          <div style={st.titolo}>🧾 Fatture di vendita</div>
          <div style={st.nota}>Le fatture emesse da Tieni il Conto: trascina gli XML nella Cassetta qui sopra, si registrano da sole. Il gestionale non emette fatture e non tocca Tieni il Conto.</div>
        </div>
        <select style={st.inp} value={anno} onChange={e => setAnno(e.target.value)}>{anni.map(a => <option key={a}>{a}</option>)}</select>
        <button style={st.btn(false)} disabled={occupato} onClick={importa}>{occupato ? "Un momento…" : "📂 Importa dal NAS"}</button>
      </div>
      {avviso && <div style={{ ...st.card, borderColor: /⚠️/.test(avviso) ? C.err : C.ok, whiteSpace: "pre-line", fontSize: 13 }}>{avviso}</div>}
      {errore && <div style={{ ...st.card, borderColor: C.err, color: C.err, fontSize: 13 }}>⚠️ {errore}</div>}

      {fatture.length === 0 ? <div style={{ ...st.card, ...st.nota }}>Nessuna fattura registrata. Premi «Importa dal NAS» per leggere la cartella dms_{anno}/vendite.</div> : (
        <>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 10, marginBottom: 14 }}>
            <Riquadro label={"Fatturato " + anno} val={euro(imponibile)} sotto={"senza IVA · " + nFatture + " fatture" + (nNote ? ", " + nNote + " note di credito" : "")} />
            <Riquadro label={"IVA " + anno} val={euro(iva)} />
            <Riquadro label="Da incassare" val={euro(daIncassare)} sotto={aperte.length + " fatture, tutti gli anni"} col={daIncassare > 0 ? C.err : C.ok} />
            <Riquadro label="Oltre 30 giorni" val={euro(vecchie.reduce((s, v) => s + stato.perId[v.id].residuo, 0))} sotto={vecchie.length + " fatture"} col={vecchie.length ? C.accent : C.ok} />
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
            {[["incassare", "Da incassare " + aperte.length, C.err], ["cantieri", "Per cantiere", C.accent], ["tutte", "Tutte " + dellAnno.length, C.accent], ["iva", "IVA per mese", C.accent]].concat(daCollegare.length ? [["collega", "Da collegare " + daCollegare.length, C.info]] : []).map(([id, l, col]) => (
              <span key={id} onClick={() => setVista(id)} style={st.chip(vista === id, col)}>{l}</span>
            ))}
          </div>

          {vista === "incassare" && (
            <div style={st.card}>
              <div style={st.titolo}>Da incassare, dalla più vecchia</div>
              {aperte.length === 0 ? <div style={st.nota}>Tutto incassato.</div> : aperte.map(riga)}
              <div style={{ ...st.nota, marginTop: 10 }}>L'importo è quello che deve arrivare davvero: senza ritenuta e senza IVA con lo split payment. Tocca una fattura per il dettaglio. Una fattura pagata fuori da questi conti si chiude con «Segna incassata».</div>
            </div>
          )}
          {vista === "cantieri" && (
            <div style={st.card}>
              <div style={st.titolo}>Per cantiere</div>
              {perCantiere.length === 0 && <div style={st.nota}>Nessuna fattura collegata a un cantiere.</div>}
              {perCantiere.map(c => (
                <div key={c.cantiereId} style={{ borderTop: "1px solid " + C.border, padding: "9px 0" }}>
                  <div style={{ display: "flex", gap: 10, alignItems: "baseline" }}>
                    <span style={{ flex: 1, minWidth: 0, fontWeight: 700, fontSize: 14 }}>{nomeCant(c.cantiereId)}</span>
                    <span style={{ fontWeight: 800, color: c.daIncassare > 0 ? C.err : C.ok, whiteSpace: "nowrap" }}>{c.daIncassare > 0 ? euro(c.daIncassare) : "incassato"}</span>
                  </div>
                  <div style={{ ...st.nota, marginTop: 2 }}>Fatturato {euro(c.imponibile)} + IVA = {euro(c.totale)} · deve arrivare {euro(c.atteso)} · pagamenti segnati {euro(c.incassato)}{c.contanti ? " · contanti " + euro(c.contanti) : ""}</div>
                  {c.eccedenza > 0 && <div style={{ fontSize: 12, color: C.accent, marginTop: 2 }}>⚠️ I pagamenti segnati superano le fatture di {euro(c.eccedenza)}: controlla che non ci siano doppioni o un pagamento senza IVA.</div>}
                </div>
              ))}
              {senzaCant > 0 && <div style={{ ...st.nota, borderTop: "1px solid " + C.border, paddingTop: 8 }}>Senza cantiere: {euro(senzaCant)} da incassare (vedi «Da incassare»).</div>}
            </div>
          )}
          {vista === "tutte" && (
            <div style={st.card}>
              <input style={{ ...st.inp, width: "100%", boxSizing: "border-box", marginBottom: 10 }} placeholder="Cerca cliente, numero, cantiere…" value={cerca} onChange={e => setCerca(e.target.value)} />
              {tutte.map(riga)}
              {tutte.length === 0 && <div style={st.nota}>Nessuna fattura.</div>}
            </div>
          )}
          {vista === "iva" && (
            <div style={st.card}>
              <div style={st.titolo}>IVA {anno} per mese</div>
              <div style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13, minWidth: 340 }}>
                  <thead><tr style={{ color: C.muted }}><th style={{ textAlign: "left", padding: 6 }}>Mese</th><th style={{ textAlign: "right", padding: 6 }}>Vendite</th><th style={{ textAlign: "right", padding: 6 }}>Acquisti</th><th style={{ textAlign: "right", padding: 6 }}>Differenza</th></tr></thead>
                  <tbody>
                    {iv.map((m, i) => (m.vendite || m.acquisti) ? <tr key={i} style={{ borderTop: "1px solid " + C.border }}><td style={{ padding: 6 }}>{MESI[i]}</td><td style={{ textAlign: "right", padding: 6 }}>{euro(m.vendite)}</td><td style={{ textAlign: "right", padding: 6 }}>{euro(m.acquisti)}</td><td style={{ textAlign: "right", padding: 6, fontWeight: 700, color: m.differenza > 0 ? C.err : C.ok }}>{euro(m.differenza)}</td></tr> : null)}
                    <tr style={{ borderTop: "2px solid " + C.border, fontWeight: 800 }}><td style={{ padding: 6 }}>Totale</td>{["vendite", "acquisti", "differenza"].map(k => <td key={k} style={{ textAlign: "right", padding: 6 }}>{euro(iv.reduce((s, m) => s + m[k], 0))}</td>)}</tr>
                  </tbody>
                </table>
              </div>
              <div style={{ ...st.nota, marginTop: 8 }}>Conto indicativo: acquisti dai documenti della Cassetta, fatture con split payment escluse. Non tiene conto dell'IVA non detraibile né dei versamenti: la cifra da pagare la dà il commercialista.</div>
            </div>
          )}
          {vista === "collega" && <DaCollegare fatture={daCollegare} cantieri={cantOrd} vendite={fatture} salvaLista={salvaLista} occupato={occupato} />}
        </>
      )}
    </div>
  );
}
